<template>
  <div class="comparison-container" ref="comparisonContainer">
    <!-- 左侧双打孔模块 -->
    <div class="comparison-item left-item">
      <h2 class="item-title">{{ $t('series.double_punching') }}</h2>
      <div class="image-wrapper">
        <img src="../../static/series/dakong2.png"  class="item-image"/>
      </div>
    </div>

    <!-- 右侧单打孔模块 -->
    <div class="comparison-item right-item">
      <h2 class="item-title">{{ $t('series.punching') }}</h2>
      <div class="image-wrapper">
        <img src="../../static/series/dakong1.png"  class="item-image"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PunchingComparison',
  data() {
    return {}
  },
  mounted() {
    this.$nextTick(() => {
      // 获取整个容器元素
      const container = this.$refs.comparisonContainer;
      const containerHeight = container.offsetHeight;

      // 初始化容器状态 - 从下方200px位置开始
      this.$gsap.set(container, {
        y: 500,
        visibility: 'visible',
        transformPerspective: 1000,
        rotationX: 3
      });

      // 计算合理的停留时间（基于容器高度和窗口高度）
      const viewportHeight = window.innerHeight;
      const minDisplayTime = 1; // 最小停留时间（秒）
      const containerRatio = containerHeight / viewportHeight;
      const displayTime = Math.max(minDisplayTime, containerRatio * 1.5);

      // 创建包含滚动触发的时间线，整合所有动画
      const timeline = this.$gsap.timeline({
        scrollTrigger: {
          trigger: container,
          start: 'top 70%',
          end: `bottom 0%`,
          markers: false,
          toggleActions: 'play none none none',
          // scrub: 1.5,
          once: true
        }
      });

      // 入场动画：从下方滑入并显示
      timeline.to(container, {
        y: 0,
        rotationX: 0,
        duration: 0.8,
        ease: 'power2.in'
      }, 0);

      // 添加明确的停留时间，元素完全可见时保持不动
      timeline.to({}, {duration: displayTime});

      // 离场动画：当继续向下滚动时，向上滑出并隐藏
      // timeline.to(container, {
      //   y: -200,          // 向上移动
      //   // opacity: 0,       // 淡出
      //   rotationX: -3,    // 轻微向上旋转
      //   duration: 1,
      //   ease: 'power2.out'
      // });
    });
  }
}
</script>

<style scoped>
/* 容器布局 - 左右并排带间距 */
.comparison-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: 0em auto;
  box-sizing: border-box;
  height: 100vh;
  /* 添加硬件加速 */
  will-change: transform, opacity;
  margin-top: 200px;
}

/* 项目基础样式 - 各占一半宽度 */
.comparison-item {
  flex: 1;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  position: relative;
  height: 650px;
  box-sizing: border-box;
  overflow: hidden; /* 确保内容不超出圆角 */
}

/* 标题样式 - 去除背景颜色 */
.item-title {
  font-size: 1.8em;
  margin-bottom: 40px;
  padding: 10px 20px;
  z-index: 10;
  font-weight: 600;
}

/* 左侧项目 - 黑色背景 */
.left-item {
  background-color: #000;
  color: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  height: 100%;
}

/* 右侧项目 - 白色背景带边框 */
.right-item {
  background-color: #fff;
  color: #000;
  height: 100%;
  border: none;
}

/* 图片容器 */
.image-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}

/* 图片样式 - 确保左右一致 */
.item-image {
  position: absolute;
  bottom: 0;
  max-width: 90%;
  max-height: 80%;
  object-fit: contain;
  object-position: center;
  width: 550px;
  height: 550px;
}

/* 平板设备优化 */
@media (max-width: 768px) {
  .comparison-item {
    height: 500px;
    padding: 30px 15px;
    min-width: 250px;
  }

  .item-title {
    font-size: 1.5em;
    margin-bottom: 25px;
  }

  .item-image {
    max-width: 95%;
    max-height: 80%;
  }
}

/* 手机端优化 */
@media (max-width: 480px) {
  .comparison-container {
    margin-top: 100px;
    flex-direction: column;
    gap: 15px;
    padding: 0 10px;
  }

  .comparison-item {
    height: 400px;
    width: 100%;
    padding: 25px 10px;
  }

  .item-title {
    font-size: 1.3em;
    margin-bottom: 20px;
  }

  .image-wrapper {
    padding: 10px;
  }

  .item-image {
    max-width: 50%;
    max-height: 85%;
  }
}
</style>
